import { PlayslipTheme, PlayslipThemeColors } from '@Generated/back-office-client/src'
import { EMPTY_COLORS_FORM, COLOR_ROLES } from './constants'
import { ThemeColorsFormData, ThemeMessagesFormData } from './types'

export const toColorsFormData = (theme: PlayslipTheme): ThemeColorsFormData => {
  const form = { ...EMPTY_COLORS_FORM }

  COLOR_ROLES.forEach(({ role }) => {
    form[role] = theme.colors[role] ?? ''
  })

  return form
}

/** A role left blank is left out, which is how the endpoint expresses "keep the built-in colour". */
export const toColorsRequest = (form: ThemeColorsFormData): PlayslipThemeColors => {
  const colors: PlayslipThemeColors = {}

  COLOR_ROLES.forEach(({ role }) => {
    const value = form[role].trim()
    if (value) {
      colors[role] = value
    }
  })

  return colors
}

export const toMessagesFormData = (theme: PlayslipTheme): ThemeMessagesFormData => ({
  ...theme.messages,
})

const placeholdersOf = (text: string): string[] =>
  [...text.matchAll(/\{(\w+)\}/g)].map((match) => match[1])

/** Words in braces the default does not use, which the app could not fill in. */
export const unknownPlaceholders = (text: string, defaultText: string): string[] => {
  const allowed = placeholdersOf(defaultText)

  return placeholdersOf(text).filter((name) => !allowed.includes(name))
}

/** Shared so a save in the editor refreshes the swatches on the list. */
export const themesQueryKey = (customerId: string | null | undefined): string[] => [
  `${customerId}-playslip-themes`,
]

export const themeQueryKey = (customerId: string | null | undefined, themeId: string): string[] => [
  `${customerId}-playslip-theme-${themeId}`,
]

/** The catalog is the same for every customer, but the request is made under one. */
export const messageCatalogQueryKey = (customerId: string | null | undefined): string[] => [
  `${customerId}-playslip-messages-catalog`,
]
